<template>
  <div>
    <MasterLayout>
      <div class="fuel_consumption_row">
        <div class="card_container" style="flex: 0 0 20%">
          <div class="row align-items-center fuel_consumption_buttons_row">
            <div class="col-md-12 fuel_consumption_btn_div mt-3">
              <div
                class="fuel_consumption_button"
                style="height: 80px; width: 80px"
              >
                <h6 class="primary_text" style="">{{ faultsNo }}</h6>
              </div>
              <div class="text-center voucher_type mt-2 primary_text">
                {{ $t("text.pumpsFault.total") }}
              </div>
            </div>
          </div>
        </div>
        <div class="card_container" style="flex: 0 0 20%">
          <div class="row align-items-center fuel_consumption_buttons_row">
            <div class="col-md-12 fuel_consumption_btn_div mt-3">
              <div
                class="fuel_consumption_button installed__tanks_dropdown__row showAllContainer"
                width="100%"
                style="
                  width: 100%;
                  padding: 5px;
                  background: rgb(75, 44, 114);
                  cursor: pointer;
                "
              >
                <div
                  class="row installed__pumps_dropdown align-items-center"
                  @click="toggleTransactionsDropDown"
                  v-on:mouseleave="
                    showStatusOPtions === true
                      ? (showStatusOPtions = false)
                      : ''
                  "
                >
                  <div class="col-md-3 dropdown_img">
                    <img src="@/assets/img/y.png" />
                  </div>
                  <div class="col-md-7">
                    <input
                      type="text"
                      class="installed__pumps_dropdown_input"
                      readonly
                      v-model="pumpStatus"
                    />
                  </div>
                  <div class="col-md-2">
                    <div>
                      <i
                        style="float: right; font-size: 25px; color: white"
                        class="fa fa-angle-right"
                        :class="[showStatusOPtions ? 'downArrow' : 'upArrow']"
                      ></i>
                    </div>
                  </div>

                  <div
                    class="return_balance_to_drop_dwon"
                    ref="balance_to_drop_down_menu"
                    v-if="showStatusOPtions"
                  >
                    <hr class="mt-2" />
                    <div
                      class="row mt-2 active_validity_drop_down_list align-items-center"
                      ref="balance_to_list_row"
                      @click="selectItem($t('text.pumpsFault.showAll'))"
                      style="height: 40px"
                    >
                      <div class="col-md-12 text-center">
                        <h6
                          class="dropdown_header_text mt-2 validity_drop_down_list"
                          ref="validity_drop_down_list"
                        >
                          {{ $t("text.pumpsFault.showAll") }}
                        </h6>
                      </div>
                    </div>
                    <div
                      class="row mt-2 active_validity_drop_down_list align-items-center"
                      ref="balance_to_list_row"
                      style="height: 40px"
                      @click="selectItem($t('text.pumpsFault.pending'))"
                    >
                      <div class="col-md-12 text-center">
                        <h6
                          class="dropdown_header_text mt-2 validity_drop_down_list"
                          ref="validity_drop_down_list"
                        >
                          {{ $t("text.pumpsFault.pending") }}
                        </h6>
                      </div>
                    </div>
                    <div
                      class="row mt-2 active_validity_drop_down_list align-items-center"
                      style="height: 40px"
                      ref="balance_to_list_row"
                      @click="selectItem($t('text.pumpsFault.fixing'))"
                    >
                      <div class="col-md-12 text-center">
                        <h6
                          class="dropdown_header_text mt-2 validity_drop_down_list"
                          ref="validity_drop_down_list"
                        >
                          {{ $t("text.pumpsFault.fixing") }}
                        </h6>
                      </div>
                    </div>
                    <div
                      class="row mt-2 active_validity_drop_down_list align-items-center"
                      ref="balance_to_list_row"
                      style="height: 40px"
                      @click="selectItem($t('text.pumpsFault.fixed'))"
                    >
                      <div class="col-md-12 text-center">
                        <h6
                          class="dropdown_header_text mt-2 validity_drop_down_list"
                          ref="validity_drop_down_list"
                        >
                          {{ $t("text.pumpsFault.fixed") }}
                        </h6>
                      </div>
                    </div>
                    <div
                      class="row mt-2 active_validity_drop_down_list align-items-center"
                      ref="balance_to_list_row"
                      style="height: 40px"
                      @click="selectItem($t('text.pumpsFault.notFixed'))"
                    >
                      <div class="col-md-12 text-center">
                        <h6
                          class="dropdown_header_text mt-2 validity_drop_down_list"
                          ref="validity_drop_down_list"
                        >
                          {{ $t("text.pumpsFault.notFixed") }}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="text-center voucher_type mt-2 primary_text">
                {{ $t("text.pumpsFault.pumpStatus") }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="fuel_consumption_row_right_section_nw pmp__bg"
          :style="[
            {
              backgroundImage: `linear-gradient(rgb(12, 4, 31 , 0.92), rgb(12, 4, 31, 0.92)), url(${backgroundUrl})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            },
          ]"
        >
          <div class="row align-items-center" style="height: 100%">
            <div class="col-md-12">
              <div
                class="transaction_period_text text-center branch__sales__text"
                style="font-size: 22px"
              >
                {{ $t("text.pumpsFault.title") }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <section class="mt-3 pump__details__section_2">
        <div class="row add_driver_row record__expenses">
          <div
            v-show="formMode === 'create'"
            class="col-md-12 col-lg-4 mt-3"
            style="padding-right: 0px"
          >
            <div class="drivers_list">
              <div class="product_summary__wrapper" style="padding: 1px">
                <div class="input__group__block mt-5" style="width: 90%">
                  <h6 class="expense__header mt-3 text-center">
                    <img stc="@/assets/img/description.png" width="25px" />
                    {{ $t("text.pumpsFault.recordFault") }}
                  </h6>
                  <label class="required">{{
                    $t("text.pumpsFault.fault")
                  }}</label>
                  <div class="input__block" ref="amount_input_div">
                    <input
                      type="text"
                      :placeholder="$t('text.pumpsFault.fault')"
                      class="form-control"
                      v-model="fault"
                    />
                  </div>
                  <div ref="amount_error"></div>
                </div>
                <div class="input__group__block mt-4" style="width: 90%">
                  <label class="required">{{
                    $t("text.pumpsFault.pump")
                  }}</label>
                  <div class="input__block">
                    <select v-model="pump">
                      <option disabled>
                        {{ $t("text.pumpsFault.selectPump") }}
                      </option>
                      <option
                        :value="pump.id"
                        v-for="(pump, i) in pumpList"
                        :key="i"
                      >
                        {{ pump.displayName }}
                      </option>
                    </select>
                  </div>
                </div>

                <div
                  class="input__group__block mt-4"
                  ref="account_textbox"
                  style="width: 90%"
                >
                  <label class="required">{{
                    $t("text.pumpsFault.status")
                  }}</label>
                  <div class="input__block" ref="account_number_input_div">
                    <select v-model="status">
                      <option disabled selected>
                        {{ $t("text.pumpsFault.selectPumpStatus") }}
                      </option>
                      <option value="pending">
                        {{ $t("text.pumpsFault.pending") }}
                      </option>
                      <option value="fixing">
                        {{ $t("text.pumpsFault.fixing") }}
                      </option>
                      <option value="fixed">
                        {{ $t("text.pumpsFault.fixed") }}
                      </option>
                      <option value="not fixed">
                        {{ $t("text.pumpsFault.notFixed") }}
                      </option>
                    </select>
                  </div>
                  <div ref="account_number_error"></div>
                </div>

                <div
                  class="input__group__block mt-4"
                  ref="account_textbox"
                  style="width: 90%"
                >
                  <label class="required">{{
                    $t("text.pumpsFault.urgencyLevel")
                  }}</label>
                  <div class="input__block" ref="account_number_input_div">
                    <select v-model="urgencyLevel">
                      <option disabled selected>
                        {{ $t("text.pumpsFault.urgencyLevel") }}
                      </option>
                      <option value="low">
                        {{ $t("text.pumpsFault.low") }}
                      </option>
                      <option value="medium">
                        {{ $t("text.pumpsFault.medium") }}
                      </option>
                      <option value="high">
                        {{ $t("text.pumpsFault.high") }}
                      </option>
                    </select>
                    <div ref="recip_error"></div>
                  </div>
                </div>

                <div class="text-center py-3 mt-3">
                  <button
                    class="sales_target_btn text-center"
                    @click="recordFault($event)"
                    :disabled="isButtonDisabled ? true : null"
                    :style="[
                      isButtonDisabled
                        ? { cursor: 'not-allowed' }
                        : { cursor: 'pointer' },
                    ]"
                  >
                    {{ $t("text.pumpsFault.recordFault") }}
                    <span></span>
                  </button>
                  <img
                    src="@/assets/img/git_loader.gif"
                    style="display: none"
                    width="35px"
                    class="ml-3 loader"
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            v-show="formMode === 'edit'"
            class="col-md-12 col-lg-4 mt-3"
            style="padding-right: 0px"
          >
            <div class="drivers_list">
              <div class="product_summary__wrapper" style="padding: 1px">
                <div class="input__group__block mt-3" style="width: 90%">
                  <h3 class="expense__header mt-3 text-center">
                    <img stc="@/assets/img/description.png" width="25px" />
                    {{ $t("text.pumpsFault.editFault") }}
                  </h3>
                  <label class="required">{{
                    $t("text.pumpsFault.fault")
                  }}</label>
                  <div class="input__block" ref="amount_input_div">
                    <input
                      type="text"
                      :placeholder="$t('text.pumpsFault.fault')"
                      class="form-control"
                      v-model="faultObj.fault"
                    />
                  </div>
                  <div ref="amount_error"></div>
                </div>
                <div class="input__group__block mt-4" style="width: 90%">
                  <label class="required">{{
                    $t("text.pumpsFault.pump")
                  }}</label>
                  <div class="input__block">
                    <select v-model="faultObj.pumpId">
                      <option disabled>
                        {{ $t("text.pumpsFault.selectPump") }}
                      </option>
                      <option
                        :value="pump.id"
                        v-for="(pump, i) in pumpList"
                        :key="i"
                      >
                        {{ pump.displayName }}
                      </option>
                    </select>
                  </div>
                </div>

                <div
                  class="input__group__block mt-4"
                  ref="account_textbox"
                  style="width: 90%"
                >
                  <label class="required">{{
                    $t("text.pumpsFault.status")
                  }}</label>
                  <div class="input__block" ref="account_number_input_div">
                    <select v-model="faultObj.status">
                      <option disabled selected>
                        {{ $t("text.pumpsFault.selectPumpStatus") }}
                      </option>
                      <option value="pending">
                        {{ $t("text.pumpsFault.pending") }}
                      </option>
                      <option value="fixing">
                        {{ $t("text.pumpsFault.fixing") }}
                      </option>
                      <option value="fixed">
                        {{ $t("text.pumpsFault.fixed") }}
                      </option>
                      <option value="not fixed">
                        {{ $t("text.pumpsFault.notFixed") }}
                      </option>
                    </select>
                  </div>
                  <div ref="account_number_error"></div>
                </div>

                <div
                  class="input__group__block mt-4"
                  ref="account_textbox"
                  style="width: 90%"
                >
                  <label class="required">{{
                    $t("text.pumpsFault.urgencyLevel")
                  }}</label>
                  <div class="input__block" ref="account_number_input_div">
                    <select v-model="faultObj.urgencyLevel">
                      <option disabled selected>
                        {{ $t("text.pumpsFault.urgencyLevel") }}
                      </option>
                      <option value="low">
                        {{ $t("text.pumpsFault.low") }}
                      </option>
                      <option value="medium">
                        {{ $t("text.pumpsFault.medium") }}
                      </option>
                      <option value="high">
                        {{ $t("text.pumpsFault.high") }}
                      </option>
                    </select>
                    <div ref="recip_error"></div>
                  </div>
                </div>
                <!-- <div
                  class="input__group__block mt-4"
                  ref="account_textbox"
                  style="width: 90%"
                >
                  <label class="required">{{
                    $t("text.pumpsFault.urgencyLevel")
                  }}</label>
                  <div class="input__block" ref="account_number_input_div">
                    <div class="input__block" ref="account_number_input_div">
                      <input
                        type="text"
                        :placeholder="$t('text.pumpsFault.urgencyLevel')"
                        class="form-control"
                        v-model="faultObj.urgencyLevel"
                      />
                      <div ref="recip_error"></div>
                    </div>
                  </div>
                </div> -->

                <div class="text-center py-3 mt-3">
                  <button
                    class="sales_target_btn text-center"
                    @click="editPumpFault($event)"
                    :disabled="isButtonDisabled ? true : null"
                    :style="[
                      isButtonDisabled
                        ? { cursor: 'not-allowed' }
                        : { cursor: 'pointer' },
                    ]"
                  >
                    {{ $t("text.pumpsFault.updateFault") }}
                    <span></span>
                  </button>
                  <button
                    class="sales_target_btn text-center ml-3"
                    style="background: #099eab"
                    @click="changeFormMode"
                  >
                    {{ $t("text.pumpsFault.addNewFault") }}
                  </button>
                  <img
                    src="@/assets/img/git_loader.gif"
                    style="display: none"
                    width="35px"
                    class="ml-3 loader"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12 col-lg-8 mt-3">
            <ejs-grid
              v-show="!showLoader"
              ref="dataGrid"
              :created="refreshGrid"
              :allowPaging="true"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="toolbarClick"
              :excelQueryCellInfo="excelQueryCellInfo"
              :locale="usedLang"
            >
              <e-columns>
                <e-column width="50" field="index" headerText="#"></e-column>
                <e-column
                  field="pumpName"
                  width="200"
                  :headerText="$t('text.pumpsFault.pumpName')"
                ></e-column>
                <e-column
                  width="180"
                  field="fault"
                  :headerText="$t('text.pumpsFault.fault')"
                ></e-column>
                <e-column
                  field="status"
                  width="180"
                  :headerText="$t('text.pumpsFault.status')"
                ></e-column>
                <e-column
                  field="urgencyLevel"
                  width="180"
                  :headerText="$t('text.pumpsFault.urgencyLevel')"
                ></e-column>
                <e-column
                  field="date"
                  width="200"
                  :format="formatOptions"
                  type="date"
                  :headerText="$t('text.pumpsFault.date')"
                ></e-column>
                <e-column
                  width="200"
                  :template="actionButtonsTemplate"
                  :headerText="$t('text.actionButtons.title')"
                ></e-column>
              </e-columns>
            </ejs-grid>
            <TableLoader :showLoader="showLoader" />
          </div>
        </div>
        <EditFault :fault="faultObj"></EditFault>
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Branch/MasterLayout.vue";
import backgroundUrl from "@/assets/img/pumpimage.png";
import configObject from "@/config";
import EditFault from "@/components/modals/Pumps/EditFault.vue";
import TableLoader from "@/components/tableLoader/index";

import Logo from "@/assets/img/logo.png";
import countryProducts from "@/products";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
  GridPlugin,
} from "@syncfusion/ej2-vue-grids";
import JQuery from "jquery";
let $ = JQuery;

export default {
  name: "Pump_Details",
  components: {
    MasterLayout,
    EditFault,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport, Resize],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      formatOptions: { type: "date", format: "dd/MM/yyyy hh:mm a" },
      // countryProducts: localStorage.getItem('countryProducts') ? JSON.parse(localStorage.countryProducts) : countryProducts,
      faultObj: {},
      tanks: [],
      pumpList: [],
      faultsNo: 0,
      products: [],
      backgroundUrl,
      pump: this.$t("text.pumpsFault.selectPump"),
      status: this.$t("text.pumpsFault.selectPumpStatus"),
      pumpStatus: this.$t("text.pumpsFault.showAll"),
      urgencyLevel: this.$t("text.pumpsFault.urgencyLevel"),
      date: "",
      fault: "",
      showStatusOPtions: false,
      formIsValid: false,
      isButtonDisabled: false,
      showLoader: false,
      branch: {},
      branchId: null,
      formMode: "create",
      bankAccounts: null,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      actionButtonsTemplate: function () {
        return {
          template: Vue.component("actionButtonsTemplate", {
            template:
              '<div class="btn-group btn-group-sm" role="group">' +
              '<button type="button" class="btn btn-primary" title="Edit Fault" v-on:click="edit_fault(data)" >' +
              '<i class="fa fa-edit" aria-hidden="true"></i>' +
              "</button>" +
              '<button type="button" class="btn btn-danger" title="Delete Fault" v-on:click="removeFault(data.id)" >' +
              '<i class="fa fa-trash-o" aria-hidden="true"></i>' +
              "</button>" +
              "</div>",
            data: function () {
              return {
                data: {},
              };
            },
            methods: {
              edit_fault: function (fault) {
                this.$eventHub.$emit("_editFault", fault);
              },

              removeFault: function (id) {
                this.$eventHub.$emit("_removeFault", id);
              },
            },
          }),
        };
      },
    };
  },
  created() {
    document.title = "Record Faults:: Epump Retail Outlet";
    // this.dateRange = this.pluginStartDate;
    this.$eventHub.$on("_removeFault", (id) => {
      this.deleteFault(id);
    });
    this.$eventHub.$on("_editFault", (fault) => {
      this.editFault(fault);
    });

    this.showLoader = true;
    this.$eventHub.$on("branch", (branch) => {
      this.branch = branch;
      document.title = `Record Faults:: ${branch.name} Retail Outlet`;
    });
  },
  computed: {
    countryProducts: function () {
      return this.$store.getters.getCountryProducts;
    },
  },
  beforeDestroy() {
    this.$eventHub.$off("_editFault");
    this.$eventHub.$off("_removeFault");
  },
  watch: {
    branch: function (newBranch, oldBranch) {
      if (newBranch.id) {
        this.branchId = this.branch.id;
        if (this.branchId !== null) {
          $(".e-input").keyup(function (e) {
            searchFun(e);
          });
          function searchFun(event) {
            var grid =
              document.getElementsByClassName("e-grid")[0].ej2_instances[0];
            var value = event.target.value;
            grid.search(value);
          }
          this.getPumps();
          this.getPumpsFaults();
        }
      }
    },
  },
  mounted() {},
  methods: {
    excelQueryCellInfo(args) {
      if (args.column.field == "date") {
        args.value = this.$moment(args.value).format("DD/MM/YYYY hh:mm A");
      }
    },
    selectItem(status) {
      this.pumpStatus = status;
      this.getPumpsFaults();
    },
    openEditPumpFault() {
      this.$modal.show("editFault");
    },
    toggleTransactionsDropDown() {
      this.showStatusOPtions = !this.showStatusOPtions;
    },
    editFault(fault) {
      let faultDetail = this.faults.filter((ft) => ft.id === fault.id)[0];
      this.faultObj = faultDetail;
      this.formMode = "edit";
      this.date = fault.dateUnformatted;
    },
    deleteFault(id) {
      const remove = confirm(this.$t("text.pumpsFault.confirmDelete"));
      if (!remove) {
        return;
      }
      let data = {
        id: id,
      };
      fetch(`${configObject.apiBaseUrl}/Pumps/Fault`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: configObject.authConfig().headers.Authorization,
        },
        body: JSON.stringify(data),
      })
        .then((res) => {
          this.getPumpsFaults();
          this.$toast.open({
            message: this.$t("text.pumpsFault.successfullyDeleted"),
            type: "success",
            duration: 4000,
          });
        })
        .catch((error) => {
          this.$toast.open({
            message: this.$t("text.pumpsFault.unsuccessfulDelete"),
            type: "error",
            duration: 4000,
          });
        });
    },
    changeFormMode() {
      this.formMode = "create";
    },
    recordFault($event) {
      if (!this.fault) {
        this.$toast.open({
          message: this.$t("text.pumpsFault.faultMissing"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      if (!this.pump || this.pump === this.$t("text.pumpsFault.selectPump")) {
        this.$toast.open({
          message: this.$t("text.pumpsFault.pumpMissing"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      if (
        !this.status ||
        this.status === this.$t("text.pumpsFault.selectPumpStatus")
      ) {
        this.$toast.open({
          message: this.$t("text.pumpsFault.statusMissing"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      if (!this.urgencyLevel) {
        this.$toast.open({
          message: this.$t("text.pumpsFault.urgencyMissing"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      // if (!this.dateRange) {
      //   this.$toast.open({
      //     message: this.$t('text.errors.dateMissing'),
      //     type: "error",
      //     duration: 5000
      //   });
      //   return;
      // }
      let data = {
        branchId: this.branchId,
        pumpId: this.pump,
        fault: this.fault,
        urgencyLevel: this.urgencyLevel,
        status: this.status,
        // date: this.startDate
      };

      this.isButtonDisabled = true;
      $(".loader").show();
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Pumps/Fault`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          this.$eventHub.$emit("refreshPumpFaultsTable");
          this.isButtonDisabled = true;
          this.pump = null;
          this.urgencyLevel = null;
          this.status = null;
          this.fault = null;
          // this.date = null;
          this.$toast.open({
            message: this.$t("text.pumpsFault.successfullyAdded"),
            type: "success",
            duration: 5000,
          });
          $(".loader").hide();
          this.isButtonDisabled = false;
          this.$modal.hide("recordFault");
          this.getPumpsFaults();
        })
        .catch(() => {
          this.$toast.open({
            message: this.$t("text.pumpsFault.unsuccessfulAdd"),
            type: "error",
            duration: 5000,
          });
          this.isButtonDisabled = false;
          $(".loader").hide();
        });
    },
    editPumpFault($event) {
      if (!this.faultObj.fault) {
        this.$toast.open({
          message: this.$t("text.pumpsFault.faultMissing"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      if (!this.faultObj.urgencyLevel) {
        this.$toast.open({
          message: this.$t("text.pumpsFault.urgencyMissing"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      if (!this.faultObj.pumpId) {
        this.$toast.open({
          message: this.$t("text.pumpsFault.pumpMissing"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      if (!this.faultObj.status) {
        this.$toast.open({
          message: this.$t("text.pumpsFault.statusMissing"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      // if (!this.dateRange) {
      //   this.$toast.open({
      //     message: this.$t('text.errors.dateMissing'),
      //     type: "error",
      //     duration: 5000
      //   });
      //   return;
      // }
      let data = {
        branchId: this.branchId,
        pumpId: this.faultObj.pumpId,
        fault: this.faultObj.fault,
        urgencyLevel: this.faultObj.urgencyLevel,
        status: this.faultObj.status,
        date: this.date,
        id: this.faultObj.id,
      };

      this.isButtonDisabled = true;
      $(".loader").show();
      this.axios
        .put(
          `${configObject.apiBaseUrl}/Pumps/Fault`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          this.isButtonDisabled = true;
          this.pump = null;
          this.urgencyLevel = null;
          this.fault = null;
          this.urgencyLevel = null;
          this.date = null;
          this.$toast.open({
            message: this.$t("text.pumpsFault.successfullyEdited"),
            type: "success",
            duration: 5000,
          });
          $(".loader").hide();
          this.isButtonDisabled = false;
          this.getPumpsFaults();
          this.formMode = "create";
        })
        .catch((e) => {
          this.$toast.open({
            message: this.$t("text.pumpsFault.unsuccessfulEdit"),
            type: "error",
            duration: 5000,
          });
          this.isButtonDisabled = false;
          $(".loader").hide();
        });
    },

    changeRoute($newRoute) {
      this.$router.push({ name: $newRoute });
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    getPumps() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/Pumps/${this.branchId}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.showLoader = false;
          response.data.forEach((element) => {
            if (element.productName !== undefined) {
              if (
                element.productName.toLowerCase() ===
                this.countryProducts.productsLower.product1
              ) {
                element.color = "#d8991c";
              } else if (
                element.productName.toLowerCase() ===
                this.countryProducts.productsLower.product2
              ) {
                element.color = "#0fce29";
              } else if (
                element.productName.toLowerCase() ===
                this.countryProducts.productsLower.product3
              ) {
                element.color = "#00aced";
              } else if (
                element.productName.toLowerCase() ===
                this.countryProducts.productsLower.product4
              ) {
                element.color = "purple";
              }
            } else if (element.displayName !== undefined) {
              if (
                element.displayName
                  .toLowerCase()
                  .includes(this.countryProducts.productsLower.product1)
              ) {
                element.color = "#d8991c";
              } else if (
                element.displayName
                  .toLowerCase()
                  .includes(this.countryProducts.productsLower.product2)
              ) {
                element.color = "#0fce29";
              } else if (
                element.displayName
                  .toLowerCase()
                  .includes(this.countryProducts.productsLower.product3)
              ) {
                element.color = "#00aced";
              } else if (
                element.displayName
                  .toLowerCase()
                  .includes(this.countryProducts.productsLower.product4)
              ) {
                element.color = "purple";
              }
            }
          });
          this.pumpList = response.data;
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    getPumpsFaults() {
      let url;
      this.showLoader = true;
      if (this.pumpStatus === this.$t("text.pumpsFault.showAll")) {
        url = `${configObject.apiBaseUrl}/Pumps/Faults/${this.branchId}`;
      }
      if (this.pumpStatus === "Pending") {
        url = `${configObject.apiBaseUrl}/Pumps/Faults/${this.branchId}/pending`;
      }
      if (this.pumpStatus === "Fixing") {
        url = `${configObject.apiBaseUrl}/Pumps/Faults/${this.branchId}/fixing`;
      }
      if (this.pumpStatus === "Fixed") {
        url = `${configObject.apiBaseUrl}/Pumps/Faults/${this.branchId}/fixed`;
      }
      if (this.pumpStatus === "Not Fixed") {
        url = `${configObject.apiBaseUrl}/Pumps/Faults/${this.branchId}/not fixed`;
      }
      this.axios
        .get(url, configObject.authConfig())
        .then((response) => {
          this.showLoader = false;
          this.faults = response.data;
          this.faultsNo = response.data.length;
          let index = 0;
          response.data.sort((a, b) => {
            return a.pumpName > b.pumpName ? 1 : -1;
          });
          response.data.forEach((element) => {
            element.index = ++index;
            element.dateUnformatted = element.date;
          });
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: response.data,
          });
          this.refreshGrid();
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    convertThousand(request) {
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>
